
/**
 * エラーメッセージを取得する
 */
export function errorMessage(
  value: keyof typeof VALIDATON_ERRORS,
  params?: { [key: string]: string | number }
): string {
  let message = VALIDATON_ERRORS[value] ?? '';
  if (message) {
    for (const key in params) {
      // 正規表現を使ってプレースホルダーを置き換える
      const placeholder = new RegExp(`\\$\\{${key}}`, 'g');
      message = message.replace(placeholder, String(params[key]));
    }
  }
  return message;
}

const VALIDATON_ERRORS = {
  REQUIRED: '${label}は必須です。',
  NUMERIC: '${label}は半角数値で入力してください。',
  EMAIL: '${label}は有効なメールアドレスではありません。',
  EMAIL2_CLEAR_NOTICE: 'メールアドレス2を空欄のまま変更すると、登録中のメールアドレス2は解除されます。',
  MAX_LENGTH: '${label}は${max}文字以下で入力してください。',
  MIN_LENGTH: '${label}は${min}文字以上入力してください。',
  PASSWORD_AUTH: 'メールアドレスまたはパスワードが正しくありません。',
  PASSWORD_ALLOWED: '${label}は半角の英数字・記号（! @ # $ % ^ & * ( ) _ + - = [ ] { } | \'）以外は利用できません。',
  PASSWORD_RULE: '${label}は英数字含む8文字以上で設定してください。',
  PASSWORD_EXPIRED: 'パスワードの有効期限が切れています。\nパスワードを変更してください。',
  PASSWORD_CONFIRM: '入力されたパスワードが一致しません',
  PASSWORD_SAME: '現在のパスワードと異なるパスワードを入力してください',
  PASSWORD_REPEAT: '${label}が一致していません。',
  ZEN_KANA: '${label}は全角カナで入力してください。',
  ZIPCODE_LENGTH: '郵便番号は7桁の半角数字を入力してください',
  YM: '${label}の入力に不備があります',
  PATTERN: '${label}に入力出来ない文字があります',
  TEL: '${label}は半角英数字で入力してください',
  REQUIRE_NOT_INCLUDE_HYPHEN: '数字のみ(ハイフン)抜きで入力してください。',
  PROHIBITED_SYMBOLS_EMAIL_LOCAL_MSG: '「@」の前の文字列に記号「${symbol}」を使用しないでください。',
  PROHIBITED_SYMBOLS_EMAIL_DOMAIN_MSG: '「@」に続く文字列に記号「${symbol}」を使用しないでください。',
  PASSWORD_VERIFY_EMAIL: 'パスワードが正しくありません。'
};
export default VALIDATON_ERRORS;
